export function formatValue(value, prefix) {
  if (prefix === "$") return `$${value.toLocaleString()}`;
  return value.toLocaleString();
}
